<template>
    <div class="equipments-profile">
        <div v-if="!noTitle" class="section-title">{{ $t('common.implements') }}</div>

        <div v-if="equipments.length === 0" class="eq-empty">
            <v-icon size="26" color="txtMuted">mdi-dumbbell</v-icon>
            <span>{{ $t('common.no_implements') }}</span>
        </div>

        <div v-else class="eq-grid">
            <div v-for="equip in equipments" :key="equip.name" class="eq-card">
                <v-img v-if="equip.src" :src="image(equip.src)" contain height="34" width="34" class="eq-img" />
                <v-icon v-else size="24" color="txtSecondary">mdi-dumbbell</v-icon>
                <span class="eq-name">{{ equipmentLabel(equip.name) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EquipmentsProfile",
    props: {
        equipments: {
            type: Array,
            default: () => [],
        },
        noTitle: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        image(src) {
            try {
                return require(`@/assets/${src}`)
            } catch (e) {
                return src
            }
        }
    }
}
</script>

<style scoped>
.section-title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--v-txtSecondary-base);
    margin-bottom: 12px;
}

.eq-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-size: 13px;
    color: var(--v-txtMuted-base);
    text-align: center;
}

.eq-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.eq-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 14px 8px 12px;
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    background: var(--v-surface2-base);
}

.eq-name {
    font-size: 12px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    text-align: center;
    line-height: 1.25;
}
</style>
